var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup708(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 260,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-background-color-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 260
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 63,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,66.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 63,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,66.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 63,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,66.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 63,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,66.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 63,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,66.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 63,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,66.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 63,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,66.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 63,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,66.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,24.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 70,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,73.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 77,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,80.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 84,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,87.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 91,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,94.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 98,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,101.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 105,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,24.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 112,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,115.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,24.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 119,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 126,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,129.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 133,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,136.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 140,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,143.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 147,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,150.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 154,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 161,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,164.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 168,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,171.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 175,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,178.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,66.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 182,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 189,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,101.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,73.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,87.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,108.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,122.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,136.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,143.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,164.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,80.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,94.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,115.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,129.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,150.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,157.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,171.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,178.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,185.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,192.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,241.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,24.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,24.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,59.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,45.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 14,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 21,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,24.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 49,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,52.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,199.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,206.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,234.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 56,
    width: 7,
    height: 7,
    transform: "rotate(0,241.5,59.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 28,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 35,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,38.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,213.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,220.5,45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 42,
    width: 7,
    height: 7,
    transform: "rotate(0,227.5,45.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,24.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 196,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,199.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 203,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,206.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 231,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,234.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,17.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,24.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,52.5,241.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 238,
    width: 7,
    height: 7,
    transform: "rotate(0,59.5,241.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 210,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,213.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 217,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,220.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,31.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,38.5,227.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 224,
    width: 7,
    height: 7,
    transform: "rotate(0,45.5,227.5)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 260,
    width: 260,
    clipPath: "url('#clip-path-background-color-0')",
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 260,
    width: 260,
    clipPath: "url('#clip-path-dot-color-0')",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    height: 49,
    width: 49,
    clipPath: "url('#clip-path-corners-square-color-0-0-0')",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    height: 21,
    width: 21,
    clipPath: "url('#clip-path-corners-dot-color-0-0-0')",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 14,
    height: 49,
    width: 49,
    clipPath: "url('#clip-path-corners-square-color-1-0-0')",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 28,
    height: 21,
    width: 21,
    clipPath: "url('#clip-path-corners-dot-color-1-0-0')",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 196,
    height: 49,
    width: 49,
    clipPath: "url('#clip-path-corners-square-color-0-1-0')",
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 210,
    height: 21,
    width: 21,
    clipPath: "url('#clip-path-corners-dot-color-0-1-0')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup708);
export default __webpack_public_path__ + "static/media/Group 708.8633b27cff590a0961c46ed3f613afc0.svg";
export { ForwardRef as ReactComponent };